module.exports = __webpack_public_path__ + "static/media/intro.40221a0c.mp3";